export const REQUEST_PREMIERE_URL = 'https://wa.me/919632788799?text=Hi%20I%E2%80%99d%20like%20to%20book%20a%20Veeflix%20memory%20premiere.%20Please%20guide%20me%20through%20the%20process.';
